import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Globe } from 'lucide-react';
import { Button } from '@/components/ui/button';

const TermsAndConditions = () => {
  const [language, setLanguage] = useState('af');

  const toggleLanguage = () => {
    setLanguage(language === 'af' ? 'en' : 'af');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-amber-50 to-orange-100 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <Link 
            to="/" 
            className="inline-flex items-center text-orange-600 hover:text-orange-700 transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            {language === 'af' ? 'Terug na Tuisblad' : 'Back to Home'}
          </Link>
          
          <Button
            onClick={toggleLanguage}
            className="bg-orange-500 hover:bg-orange-600 text-white"
            size="sm"
          >
            <Globe className="h-4 w-4 mr-2" />
            {language === 'af' ? 'English' : 'Afrikaans'}
          </Button>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8">
          {language === 'af' ? <AfrikaansContent /> : <EnglishContent />}
        </div>
      </div>
    </div>
  );
};

const AfrikaansContent = () => (
  <>
    <h1 className="text-3xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
      Terme en Voorwaardes
    </h1>
    <p className="text-sm text-gray-600 mb-8">Laas Opgedateer: 21 April 2026</p>

    <div className="space-y-6 text-gray-700">
      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Aanvaarding van Terme</h2>
        <p>
          Welkom by DIE BIBLIOTEEK. Deur toegang te verkry tot en gebruik te maak van ons platform, stem jy in tot 
          hierdie Terme en Voorwaardes. As jy nie saamstem met enige deel van hierdie terme nie, moet jy asseblief 
          nie ons diens gebruik nie.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Gebruik van die Platform</h2>
        <p className="mb-2">DIE BIBLIOTEEK bied 'n platform vir:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li><strong>Skrywers:</strong> Om Afrikaanse boeke in te dien vir proeflees en publikasie</li>
          <li><strong>Proeflees:</strong> Om boeke te proefslees en betaal te word vir hul werk (R100 per boek)</li>
          <li><strong>Administrateurs:</strong> Om die platform te bestuur en boeke goed te keur vir publikasie</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Rekeninge en Registrasie</h2>
        <p className="mb-2">Wanneer jy 'n rekeninge registreer, stem jy in om:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li>Akkurate, volledige, en huidige inligting te verskaf</li>
          <li>Jou rekeninge veilig te hou en jou wagwoord te beskerm</li>
          <li>Ons onmiddellik in te lig oor enige ongemagtigde gebruik van jou rekeninge</li>
          <li>Verantwoordelik te wees vir alle aktiwiteite onder jou rekeninge</li>
          <li>Ten minste 18 jaar oud te wees om 'n rekeninge te registreer</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Ouderdomsbeperking en Verifikasie</h2>
        <p className="mb-3">
          Deur toegang tot of gebruik van Die Biblioteek te verkry, bevestig jy dat jy 18 jaar of ouer is.
        </p>
        <p className="mb-3">
          Die platform is streng bedoel vir volwasse gebruikers, en ons versamel of verwerk nie doelbewus persoonlike 
          inligting van persone onder die ouderdom van 18 jaar nie.
        </p>
        <p className="mb-3">
          As deel van ons registrasieproses mag gebruikers versoek word om hul ouderdom te verifieer. Deur voort te gaan 
          met die gebruik van die platform, waarborg jy dat alle inligting wat verskaf is, akkuraat en waar is.
        </p>
        <p>
          Indien ons bewus raak daarvan dat 'n gebruiker jonger as 18 jaar is, behou ons die reg voor om toegang tot die 
          platform op te skort of te beeindig en enige verwante data te verwyder.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Skrywer Verpligtinge</h2>
        <p className="mb-2">As 'n skrywer, verbind jy jouself tot die volgende:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li><strong>Oorspronklike Werk:</strong> Alle boeke wat jy indien is jou oorspronklike werk of jy het die regte om dit te publiseer</li>
          <li><strong>Geen Plagiaat:</strong> Boeke mag nie geplagieer wees of die regte van ander skend nie</li>
          <li><strong>Aanvaarbare Inhoud:</strong> Boeke moet voldoen aan wetlike vereistes en mag nie onwettige, aanstootlike, of ontoepaslike inhoud bevat nie</li>
          <li><strong>Proeflees Korreksies:</strong> Jy stem in om regstellings te maak soos deur proeflees aanbeveel</li>
          <li><strong>Publikasie Regte:</strong> Jy gee DIE BIBLIOTEEK toestemming om jou goedgekeurde boeke te publiseer op ons platform</li>
          <li><strong>EPUB Formaat Vereistes:</strong> Jou boek MOET duidelike hoofstukopskrifte bevat vir korrekte EPUB-omskakeling. Aanvaarbare formate:
            <ul className="list-circle ml-6 mt-2 space-y-1">
              <li><strong>Hoofstuk 1</strong>, <strong>Hoofstuk 2</strong>, ens.</li>
              <li><strong>Hoofstuk I</strong>, <strong>Hoofstuk II</strong> (Romeinse syfers)</li>
              <li><strong>Chapter 1</strong>, <strong>Chapter 2</strong></li>
              <li><strong>Chapter I</strong>, <strong>Chapter II</strong></li>
              <li><strong>1. Titel</strong>, <strong>2. Titel</strong> (genommerde hoofstukke met titels)</li>
            </ul>
            <p className="mt-2 text-orange-600 font-medium">⚠️ Boeke sonder duidelike hoofstukopskrifte sal AFGEWYS word deur die stelsel.</p>
          </li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Proefleser Verpligtinge</h2>
        <p className="mb-2">As 'n proefleser, verbind jy jouself tot die volgende:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li><strong>Kwalifikasie Test:</strong> Jy moet ons kwalifikasie toets slaag voordat jy boeke kan proefslees</li>
          <li><strong>Professionele Proeflees:</strong> Jy moet 'n deeglike en professionele proeflees diens verskaf</li>
          <li><strong>Vertroulikheid:</strong> Jy mag nie boeke deel, kopieer, of publiseer sonder toestemming nie</li>
          <li><strong>Foutlys:</strong> Jy moet 'n volledige foutlys verskaf met duidelike aanwysings vir regstellings</li>
          <li><strong>Tydige Voltooiing:</strong> Jy stem in om werk betyds te voltooi</li>
          <li><strong>Betaling:</strong> Jy sal R100 per voltooide en goedgekeurde boek betaal word</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Intellektuele Eiendom</h2>
        <p className="mb-2">Alle intellektuele eiendom op die platform word beskerm:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li><strong>Skrywers:</strong> Behou volle outeurskap en kopiereg van hul boeke</li>
          <li><strong>Platform Inhoud:</strong> DIE BIBLIOTEEK logo, ontwerp, en sagteware is ons eiendom</li>
          <li><strong>Lisensie:</strong> Deur publikasie te aanvaar, gee jy DIE BIBLIOTEEK 'n nie-eksklusiewe lisensie om jou boek te vertoon en te verkoop</li>
          <li><strong>Geen Ongemagtigde Gebruik:</strong> Jy mag nie platform inhoud, boeke, of materiaal sonder toestemming kopieer of hergebruik nie</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Betalings en Vergoeding</h2>
        <p className="mb-2">Betalings word verwerk deur die administrateur via EFT oordrag:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li><strong>Proefleser Betaling:</strong> R100 per voltooide en goedgekeurde boek</li>
          <li><strong>Betaling Tydperk:</strong> Betalings word verwerk binne 14 dae na goedkeuring</li>
          <li><strong>Bank Besonderhede:</strong> Jy moet akkurate bank besonderhede verskaf vir betalings</li>
          <li><strong>Geen Terugbetalings:</strong> Betalings vir voltooide werk is finale en nie-terugbetaalbaar nie</li>
          <li><strong>Geskille:</strong> Enige geskille oor betalings moet binne 30 dae gerapporteer word</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">9. Boek Status en Goedkeuring Proses</h2>
        <p className="mb-2">Boeke gaan deur die volgende prosesse:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li><strong>Ingedien:</strong> Boek is deur skrywer ingedien</li>
          <li><strong>In Proeflees:</strong> Proefleser werk aan die boek</li>
          <li><strong>Wag vir Regmaak:</strong> Proefleser het foutlys verskaf, wag vir skrywer korreksies</li>
          <li><strong>Gereed vir Publikasie:</strong> Admin het boek goedgekeur vir publikasie</li>
          <li><strong>Gepubliseer:</strong> Boek is lewendig op die lees platform</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">10. Verbode Aktiwiteite</h2>
        <p className="mb-2">Die volgende is streng verbode op ons platform:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li>Oplaai van plagiaat of onwettige inhoud</li>
          <li>Skending van ander se intellektuele eiendom regte</li>
          <li>Poging om die platform te misbruik of te hack</li>
          <li>Gebruik van die platform vir fraudulente aktiwiteite</li>
          <li>Deel van vertroulike boeke sonder toestemming</li>
          <li>Skep van valse rekeninge of misverteenwoordiging</li>
          <li>Spam, teister, of aanstootlik gedrag teenoor ander gebruikers</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">11. Beëindiging van Rekeninge</h2>
        <p>
          DIE BIBLIOTEEK behou die reg voor om enige rekeninge te skors of te beëindig wat hierdie Terme en Voorwaardes 
          oortree. Ons kan ook dienste beëindig vir inaktiwiteit, misbruik, of enige rede na ons diskresie. By beëindiging 
          sal jy toegang tot jou rekeninge en inhoud verloor.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">12. Vrywaring van Aanspreeklikheid</h2>
        <p className="mb-2">DIE BIBLIOTEEK:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li>Verskaf die platform "soos dit is" sonder waarborge van enige aard</li>
          <li>Is nie aanspreeklik vir enige verlies of skade wat voortspruit uit die gebruik van die platform nie</li>
          <li>Waarborg nie die kwaliteit, akkuraatheid, of sukses van enige boek nie</li>
          <li>Is nie verantwoordelik vir geskille tussen skrywers en proeflees nie</li>
          <li>Behou die reg voor om die platform te wysig of te beëindig sonder kennisgewing</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">13. Beperking van Aanspreeklikheid</h2>
        <p>
          In geen geval sal DIE BIBLIOTEEK, sy eienaars, werknemers, of vennote aanspreeklik wees vir enige indirekte, 
          toevallige, spesiale, of gevolglike skade wat voortspruit uit jou gebruik van die platform nie. Ons maksimum 
          aanspreeklikheid sal beperk wees tot die bedrag wat jy aan ons betaal het in die afgelope 12 maande.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">14. Geskille en Wetgewing</h2>
        <p>
          Hierdie Terme en Voorwaardes word gereguleer deur die wette van Suid-Afrika. Enige geskille sal opgelos word 
          deur arbitrasie in Suid-Afrika. Deur gebruik te maak van die platform, stem jy in tot hierdie jurisdiksie en 
          plek vir enige wetlike prosedures.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">15. Wysigings aan Terme</h2>
        <p>
          DIE BIBLIOTEEK behou die reg voor om hierdie Terme en Voorwaardes op enige tyd te wysig. Ons sal jou in kennis 
          stel van wesenlike veranderinge deur 'n kennisgewing op die platform of deur e-pos. Voortgesette gebruik van 
          die platform na sulke veranderinge beteken jou aanvaarding van die nuwe terme.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">16. Skeidbaarheid</h2>
        <p>
          As enige bepaling van hierdie Terme en Voorwaardes ongeldig of onafdwingbaar gevind word, sal die oorblywende 
          bepalings ten volle in werking bly.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">17. Hele Ooreenkoms</h2>
        <p>
          Hierdie Terme en Voorwaardes, tesame met ons Privaatheidsbeleid, vorm die hele ooreenkoms tussen jou en 
          DIE BIBLIOTEEK met betrekking tot jou gebruik van die platform.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">18. Kontak Ons</h2>
        <p>
          As jy enige vrae oor hierdie Terme en Voorwaardes het, kontak ons asseblief by:
        </p>
        <div className="mt-3 p-4 bg-orange-50 rounded-lg">
          <p><strong>DIE BIBLIOTEEK</strong></p>
          <p>E-pos: Leesinafrikaans@diebiblioteek.co.za</p>
          <p>Website: https://diebiblioteek.co.za</p>
        </div>
      </section>

      <section className="border-t pt-6 mt-8">
        <p className="text-sm text-gray-600">
          Deur gebruik te maak van DIE BIBLIOTEEK platform, bevestig jy dat jy hierdie Terme en Voorwaardes gelees, 
          verstaan, en aanvaar het. As jy nie saamstem nie, moet jy asseblief nie die platform gebruik nie.
        </p>
      </section>
    </div>
  </>
);

const EnglishContent = () => (
  <>
    <h1 className="text-3xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
      Terms and Conditions
    </h1>
    <p className="text-sm text-gray-600 mb-8">Last Updated: April 21, 2026</p>

    <div className="space-y-6 text-gray-700">
      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Acceptance of Terms</h2>
        <p>
          Welcome to DIE BIBLIOTEEK. By accessing and using our platform, you agree to 
          these Terms and Conditions. If you do not agree with any part of these terms, please 
          do not use our service.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Use of the Platform</h2>
        <p className="mb-2">DIE BIBLIOTEEK provides a platform for:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li><strong>Writers:</strong> To submit Afrikaans books for proofreading and publication</li>
          <li><strong>Proofreaders:</strong> To proofread books and get paid for their work (R100 per book)</li>
          <li><strong>Administrators:</strong> To manage the platform and approve books for publication</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Accounts and Registration</h2>
        <p className="mb-2">When you register an account, you agree to:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li>Provide accurate, complete, and current information</li>
          <li>Keep your account secure and protect your password</li>
          <li>Notify us immediately of any unauthorized use of your account</li>
          <li>Be responsible for all activities under your account</li>
          <li>Be at least 18 years old to register an account</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Age Restriction & Verification</h2>
        <p className="mb-3">
          By accessing or using Die Biblioteek platform, you confirm that you are 18 years of age or older.
        </p>
        <p className="mb-3">
          The platform is strictly intended for adult users, and we do not knowingly collect or process personal 
          information from individuals under the age of 18.
        </p>
        <p className="mb-3">
          As part of our onboarding process, users may be required to verify their age. By continuing to use the 
          platform, you warrant that all information provided is accurate and truthful.
        </p>
        <p>
          If we become aware that a user is under the age of 18, we reserve the right to suspend or terminate access 
          to the platform and delete any associated data.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Writer Obligations</h2>
        <p className="mb-2">As a writer, you commit to the following:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li><strong>Original Work:</strong> All books you submit are your original work or you have the rights to publish them</li>
          <li><strong>No Plagiarism:</strong> Books must not be plagiarized or violate the rights of others</li>
          <li><strong>Acceptable Content:</strong> Books must comply with legal requirements and must not contain illegal, offensive, or inappropriate content</li>
          <li><strong>Proofreading Corrections:</strong> You agree to make corrections as recommended by proofreaders</li>
          <li><strong>Publication Rights:</strong> You give DIE BIBLIOTEEK permission to publish your approved books on our platform</li>
          <li><strong>EPUB Format Requirements:</strong> Your book MUST contain clear chapter headings for correct EPUB conversion. Acceptable formats:
            <ul className="list-circle ml-6 mt-2 space-y-1">
              <li><strong>Hoofstuk 1</strong>, <strong>Hoofstuk 2</strong>, etc.</li>
              <li><strong>Hoofstuk I</strong>, <strong>Hoofstuk II</strong> (Roman numerals)</li>
              <li><strong>Chapter 1</strong>, <strong>Chapter 2</strong></li>
              <li><strong>Chapter I</strong>, <strong>Chapter II</strong></li>
              <li><strong>1. Title</strong>, <strong>2. Title</strong> (numbered chapters with titles)</li>
            </ul>
            <p className="mt-2 text-orange-600 font-medium">⚠️ Books without clear chapter headings will be REJECTED by the system.</p>
          </li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Proofreader Obligations</h2>
        <p className="mb-2">As a proofreader, you commit to the following:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li><strong>Qualification Test:</strong> You must pass our qualification test before you can proofread books</li>
          <li><strong>Professional Proofreading:</strong> You must provide a thorough and professional proofreading service</li>
          <li><strong>Confidentiality:</strong> You may not share, copy, or publish books without permission</li>
          <li><strong>Error List:</strong> You must provide a complete error list with clear instructions for corrections</li>
          <li><strong>Timely Completion:</strong> You agree to complete work on time</li>
          <li><strong>Payment:</strong> You will be paid R100 per completed and approved book</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Intellectual Property</h2>
        <p className="mb-2">All intellectual property on the platform is protected:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li><strong>Writers:</strong> Retain full authorship and copyright of their books</li>
          <li><strong>Platform Content:</strong> DIE BIBLIOTEEK logo, design, and software are our property</li>
          <li><strong>License:</strong> By accepting publication, you give DIE BIBLIOTEEK a non-exclusive license to display and sell your book</li>
          <li><strong>No Unauthorized Use:</strong> You may not copy or reuse platform content, books, or materials without permission</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Payments and Compensation</h2>
        <p className="mb-2">Payments are processed by the administrator via EFT transfer:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li><strong>Proofreader Payment:</strong> R100 per completed and approved book</li>
          <li><strong>Payment Period:</strong> Payments are processed within 14 days of approval</li>
          <li><strong>Bank Details:</strong> You must provide accurate bank details for payments</li>
          <li><strong>No Refunds:</strong> Payments for completed work are final and non-refundable</li>
          <li><strong>Disputes:</strong> Any disputes about payments must be reported within 30 days</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">9. Book Status and Approval Process</h2>
        <p className="mb-2">Books go through the following processes:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li><strong>Submitted:</strong> Book has been submitted by writer</li>
          <li><strong>In Proofreading:</strong> Proofreader is working on the book</li>
          <li><strong>Waiting for Corrections:</strong> Proofreader has provided error list, waiting for writer corrections</li>
          <li><strong>Ready for Publication:</strong> Admin has approved book for publication</li>
          <li><strong>Published:</strong> Book is live on the reading platform</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">10. Prohibited Activities</h2>
        <p className="mb-2">The following are strictly prohibited on our platform:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li>Uploading plagiarized or illegal content</li>
          <li>Violating others' intellectual property rights</li>
          <li>Attempting to abuse or hack the platform</li>
          <li>Using the platform for fraudulent activities</li>
          <li>Sharing confidential books without permission</li>
          <li>Creating fake accounts or misrepresentation</li>
          <li>Spam, harassment, or offensive behavior towards other users</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">11. Account Termination</h2>
        <p>
          DIE BIBLIOTEEK reserves the right to suspend or terminate any account that violates these Terms and Conditions. 
          We may also terminate services for inactivity, abuse, or any reason at our discretion. Upon termination, 
          you will lose access to your account and content.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">12. Disclaimer of Liability</h2>
        <p className="mb-2">DIE BIBLIOTEEK:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li>Provides the platform "as is" without warranties of any kind</li>
          <li>Is not liable for any loss or damage arising from use of the platform</li>
          <li>Does not guarantee the quality, accuracy, or success of any book</li>
          <li>Is not responsible for disputes between writers and proofreaders</li>
          <li>Reserves the right to modify or terminate the platform without notice</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">13. Limitation of Liability</h2>
        <p>
          In no event shall DIE BIBLIOTEEK, its owners, employees, or partners be liable for any indirect, 
          incidental, special, or consequential damages arising from your use of the platform. Our maximum 
          liability shall be limited to the amount you have paid us in the past 12 months.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">14. Disputes and Governing Law</h2>
        <p>
          These Terms and Conditions are governed by the laws of South Africa. Any disputes will be resolved 
          by arbitration in South Africa. By using the platform, you agree to this jurisdiction and 
          venue for any legal proceedings.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">15. Changes to Terms</h2>
        <p>
          DIE BIBLIOTEEK reserves the right to modify these Terms and Conditions at any time. We will notify you 
          of significant changes through a notice on the platform or by email. Continued use of 
          the platform after such changes means your acceptance of the new terms.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">16. Severability</h2>
        <p>
          If any provision of these Terms and Conditions is found to be invalid or unenforceable, the remaining 
          provisions will remain in full effect.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">17. Entire Agreement</h2>
        <p>
          These Terms and Conditions, together with our Privacy Policy, constitute the entire agreement between you and 
          DIE BIBLIOTEEK regarding your use of the platform.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">18. Contact Us</h2>
        <p>
          If you have any questions about these Terms and Conditions, please contact us at:
        </p>
        <div className="mt-3 p-4 bg-orange-50 rounded-lg">
          <p><strong>DIE BIBLIOTEEK</strong></p>
          <p>Email: Leesinafrikaans@diebiblioteek.co.za</p>
          <p>Website: https://diebiblioteek.co.za</p>
        </div>
      </section>

      <section className="border-t pt-6 mt-8">
        <p className="text-sm text-gray-600">
          By using the DIE BIBLIOTEEK platform, you confirm that you have read, understood, 
          and accept these Terms and Conditions. If you do not agree, please do not use the platform.
        </p>
      </section>
    </div>
  </>
);

export default TermsAndConditions;
